<app-header></app-header>

<ion-content [scrollEvents]="false">
  <!-- Desktop View -->
  <ng-container
    *ngIf="(this.platformService?.isTouchExperience$ | async) === false"
  >
    <div id="desktop">
      <div class="top-section-background">
        <ion-grid>
          <div>
            <div class="page-title-oswald" data-cy="exceptions-page-title">
              {{ 'i18n.orderExceptionsPage.resolveExceptions' | translate }}
            </div>
            <div
              *ngIf="vm?.showResolveLater"
              class="order-exception-note"
              data-cy="exceptions-note-text"
            >
              <ion-icon name="alert-circle-outline"></ion-icon>
              {{ 'i18n.orderExceptionsPage.goBackToFinish' | translate }}
            </div>
            <div class="order-exception-count">
              <div
                class="oval-background-red"
                data-cy="exceptions-incomplete-count"
              >
                <span>{{vm?.tallies?.unresolved || 0}}</span>
              </div>
              <div class="order-exception-count-label">
                {{ 'i18n.orderExceptionsPage.remaining' | translate }}
              </div>
              <div
                class="oval-background-green"
                data-cy="exceptions-completed-count"
              >
                <span>{{vm?.tallies?.resolved || 0}}</span>
              </div>
              <div class="order-exception-count-label">
                {{ 'i18n.orderExceptionsPage.resolved' | translate }}
              </div>
            </div>
          </div>

          <h4 data-cy="exceptions-order-number"></h4>

          <div class="order-exception-details">
            <div class="order-exception-reserve-order">
              <div class="reserve-order-row">
                <div data-cy="exceptions-delivery-date-text">
                  {{ 'i18n.orderStatusPage.orderNumber' | translate }} {{
                  vm?.order?.orderHeader?.tandemOrderNumber }}
                  <br />

                  {{ 'i18n.orderExceptionsPage.pONumber' | translate }}
                  {{vm?.order?.orderHeader?.purchaseOrderNumber}}
                </div>
                <div data-cy="exceptions-reserved-text">
                  {{ 'i18n.orderExceptionsPage.deliveryDate' | translate }}
                  {{vm?.order?.orderHeader?.confirmedDeliveryDate |
                  date:'M/d/yyyy':'GMT'}}
                  <br />

                  {{ 'i18n.orderExceptionsPage.reserved' | translate }}
                  <span
                    [class.red-highlight]="vm?.tallies?.totalCasesReserved < vm?.tallies?.totalCasesOrdered"
                    >{{vm?.tallies?.totalCasesReserved}} CS</span
                  >
                  /
                  <span
                    [class.red-highlight]="vm?.tallies?.totalEachesReserved < vm?.tallies?.totalEachesOrdered"
                    >{{vm?.tallies?.totalEachesReserved}} EA</span
                  >
                </div>
              </div>
            </div>

            <div class="order-exception-actions">
              <div class="order-exception-icons">
                <div>
                  <ion-icon
                    name="share-social-outline"
                    data-cy="exceptions-share-link"
                  ></ion-icon
                  >{{ 'i18n.common.share' | translate }}
                </div>
                <div>
                  <ion-icon
                    name="download-outline"
                    data-cy="exceptions-download-link"
                  ></ion-icon
                  >{{ 'i18n.common.download' | translate }}
                </div>
                <div>
                  <ion-icon
                    name="print-outline"
                    data-cy="exceptions-print-link"
                  ></ion-icon
                  >{{ 'i18n.common.print' | translate }}
                </div>
              </div>
              <ion-button
                disabled="{{!vm?.submitEnabled}}"
                [ngClass]="!vm?.submitEnabled ? 'usf-fill-disabled-button':'usf-fill-green-button'"
                data-cy="submit-exceptions-resolution-button"
                (click)="submit()"
                >{{ 'i18n.orderExceptionsPage.submitResolvedExceptions' |
                translate }}</ion-button
              >
              <ion-button
                *ngIf="vm?.showResolveLater"
                class="usf-outline-green-button"
                (click)="resolveLaterClicked()"
                data-cy="submit-exceptions-resolve-later-button"
              >
                {{ 'i18n.orderExceptionsPage.resolveLater' | translate}}
              </ion-button>
            </div>
          </div>
        </ion-grid>
      </div>
      <div class="bottom-section-background">
        <ion-grid
          *ngFor="let item of vm?.orderExceptions | keyvalue; trackBy: trackByIndex; let first = first;"
        >
          <app-exception-section-desktop
            [orderExceptionType]="item?.key"
            [exceptionResolutions]="item?.value"
            [productMap]="vm?.productMap"
            [searchForSubsMap]="vm?.searchForSubsMap"
            [isExpanded]="vm.expandedSection.get(item.key)"
            [platformEnum]="platformService.platformType"
            [orderHeader]="vm?.order?.orderHeader"
            [selectedDate]="selectedDate"
            [restrictToOg]="vm?.restrictToOg"
            [substitutionsAllowed]="vm?.substitutionsAllowed"
            (exceptionResolved)="resolveExceptionHandler($event)"
            (isExpandedChanged)="isExpandedChanged($event, item.key)"
            (searchForSubsClicked)="openSearchForSubs($event)"
            (compareProductsClicked)="navigateToCompareProductsPage($event)"
            (updatePriceEmitter)="presentHandPricingModal($event)"
            (partialReserveFlagResolved)="resolvepartialReserveFlag($event)"
            (substituteProductFlipped)="flipSubstituteProduct($event)"
            (editRowResolved)="editRowClicked($event)"
            (cancelEditRow)="cancelEditRowHandler($event)"
            (updateDateEmitter)="updateDateHandler($event)"
            [isExpandedFirstRow]="first"
            [sellerPrice]="vm?.sellerPrice"
            [isPartialExceptionsEnabled]="isPartialExceptionsEnabled"
          ></app-exception-section-desktop>
        </ion-grid>
      </div>
    </div>
  </ng-container>

  <!-- Touch View-->
  <ng-container
    *ngIf="(this.platformService?.isTouchExperience$ | async) === true"
  >
    <!-- Tablet View -->
    <div id="tablet">
      <div class="top-section-background">
        <ion-grid>
          <div class="top-section-head">
            <div class="page-title-oswald" data-cy="exceptions-page-title">
              {{ 'i18n.orderExceptionsPage.resolveExceptions' | translate }}
            </div>

            <div class="order-exception-count">
              <div
                class="oval-background-red"
                data-cy="exceptions-incomplete-count"
              >
                <span>{{vm?.tallies?.unresolved || 0}}</span>
              </div>
              <div class="order-exception-count-label">
                {{ 'i18n.orderExceptionsPage.remaining' | translate }}
              </div>
              <div
                class="oval-background-green"
                data-cy="exceptions-completed-count"
              >
                <span>{{vm?.tallies?.resolved || 0}}</span>
              </div>
              <div class="order-exception-count-label">
                {{ 'i18n.orderExceptionsPage.resolved' | translate }}
              </div>
            </div>
          </div>

          <div
            *ngIf="vm?.showResolveLater"
            class="order-exception-note"
            data-cy="exceptions-note-text"
          >
            <ion-icon name="alert-circle-outline"></ion-icon>
            {{ 'i18n.orderExceptionsPage.goBackToFinish' | translate }}
          </div>

          <div class="order-exception-details">
            <div class="order-exception-reserve-order">
              <h4>Order #{{ vm?.order?.orderHeader?.tandemOrderNumber }}</h4>
              <div class="reserve-order-row">
                <div data-cy="exceptions-reserved-text">
                  {{ 'i18n.orderExceptionsPage.totalCasesReserved' | translate
                  }}
                  <span
                    [class.red-highlight]="vm?.tallies?.totalCasesReserved < vm?.tallies?.totalCasesOrdered"
                    >{{vm?.tallies?.totalCasesReserved}} CS </span
                  ><br />
                  {{ 'i18n.orderExceptionsPage.totalEachesReserved' | translate
                  }}
                  <span
                    [class.red-highlight]="vm?.tallies?.totalEachesReserved < vm?.tallies?.totalEachesOrdered"
                    >{{vm?.tallies?.totalEachesReserved}} EA</span
                  >
                </div>
                <div data-cy="exceptions-delivery-date-text">
                  {{ 'i18n.orderExceptionsPage.deliveryDate' | translate }}
                  {{vm?.order?.orderHeader?.confirmedDeliveryDate |
                  date:'M/d/yyyy':'GMT'}} <br />

                  {{ 'i18n.orderExceptionsPage.pONumber' | translate }}
                  {{vm?.order?.orderHeader?.purchaseOrderNumber}}
                </div>
              </div>
            </div>

            <div class="order-exception-actions">
              <ion-button
                class="usf-fill-green-button"
                disabled="{{!vm?.submitEnabled}}"
                [ngClass]="!vm?.submitEnabled ? 'usf-fill-disabled-button':'usf-fill-green-button'"
                data-cy="submit-exceptions-resolution-button"
                (click)="submit()"
              >
                {{ 'i18n.orderExceptionsPage.submitResolvedExceptions' |
                translate }}
              </ion-button>
              <ion-button
                *ngIf="vm?.showResolveLater"
                class="usf-outline-green-button"
                (click)="resolveLaterClicked()"
                data-cy="submit-exceptions-resolve-later-button"
              >
                {{ 'i18n.orderExceptionsPage.resolveLater' | translate}}
              </ion-button>
            </div>
          </div>
        </ion-grid>
      </div>
      <div class="bottom-section-background">
        <ng-container
          *ngFor="let item of vm?.orderExceptions| keyvalue; trackBy: trackByIndex; let first = first"
        >
          <app-exception-section-tablet
            [orderExceptionType]="item.key"
            [exceptionResolutions]="item.value"
            [productMap]="vm?.productMap"
            [searchForSubsMap]="vm?.searchForSubsMap"
            [isExpanded]="vm.expandedSection.get(item.key)"
            [platformEnum]="platformService.platformType"
            [orderHeader]="vm?.order?.orderHeader"
            [selectedDate]="selectedDate"
            [restrictToOg]="vm?.restrictToOg"
            [substitutionsAllowed]="vm?.substitutionsAllowed"
            (exceptionResolved)="resolveExceptionHandler($event)"
            (isExpandedChanged)="isExpandedChanged($event, item.key)"
            (searchForSubsClicked)="openSearchForSubs($event)"
            (compareProductsClicked)="navigateToCompareProductsPage($event)"
            (updatePriceEmitter)="presentHandPricingModal($event)"
            (partialReserveFlagResolved)="resolvepartialReserveFlag($event)"
            (substituteProductFlipped)="flipSubstituteProduct($event)"
            (editRowResolved)="editRowClicked($event)"
            (cancelEditRow)="cancelEditRowHandler($event)"
            (updateDateEmitter)="updateDateHandler($event)"
            [isExpandedFirstRow]="first"
            [sellerPrice]="vm?.sellerPrice"
          ></app-exception-section-tablet>
        </ng-container>
      </div>
    </div>

    <!-- Mobile View -->
    <div id="mobile">
      <div class="top-section-background">
        <ion-grid>
          <div>
            <div class="page-title-oswald" data-cy="exceptions-page-title">
              {{ 'i18n.orderExceptionsPage.resolveExceptions' | translate }}
            </div>
          </div>

          <div class="order-exception-details">
            <div class="order-exception-reserve-order">
              <h4 data-cy="exceptions-order-number">
                Order #{{ vm?.order?.orderHeader?.tandemOrderNumber }}
              </h4>
              <div class="reserve-order-row">
                <div class="labels">
                  <div>
                    {{ 'i18n.orderExceptionsPage.totalCasesReserved' | translate
                    }}
                    <span
                      [class.red-highlight]="vm?.tallies?.totalCasesReserved < vm?.tallies?.totalCasesOrdered"
                      >{{vm?.tallies?.totalCasesReserved}} CS
                    </span>
                  </div>
                  <div>
                    {{ 'i18n.orderExceptionsPage.totalEachesReserved' |
                    translate }}
                    <span
                      [class.red-highlight]="vm?.tallies?.totalEachesReserved < vm?.tallies?.totalEachesOrdered"
                      >{{vm?.tallies?.totalEachesReserved}} EA</span
                    >
                  </div>
                  <div data-cy="exceptions-delivery-date-label">
                    {{ 'i18n.orderExceptionsPage.deliveryDate' | translate }}
                    <span data-cy="exceptions-delivery-date-text"
                      >{{vm?.order?.orderHeader?.confirmedDeliveryDate |
                      date:'M/d/yyyy':'GMT'}}</span
                    >
                  </div>
                  <div data-cy="exceptions-po-label">
                    {{ 'i18n.orderExceptionsPage.pONumber' | translate }}
                    <span data-cy="exceptions-po-text"
                      >{{vm?.order?.orderHeader?.purchaseOrderNumber}}</span
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="order-exception-actions">
            <span
              *ngIf="vm?.showResolveLater"
              class="order-exception-note"
              data-cy="exceptions-note-text"
            >
              <ion-icon name="alert-circle-outline"></ion-icon>
              {{ 'i18n.orderExceptionsPage.goBackToFinish' | translate }}
            </span>
            <div class="order-exception-count">
              <div
                class="oval-background-red"
                data-cy="exceptions-incomplete-count"
              >
                <span>{{vm?.tallies?.unresolved || 0}}</span>
              </div>
              <div class="order-exception-count-label">
                {{ 'i18n.orderExceptionsPage.remaining' | translate }}
              </div>
              <div
                class="oval-background-green"
                data-cy="exceptions-completed-count"
              >
                <span>{{vm?.tallies?.resolved || 0}}</span>
              </div>
              <div class="order-exception-count-label">
                {{ 'i18n.orderExceptionsPage.resolved' | translate }}
              </div>
            </div>
            <div class="button-group">
              <ion-button
                class="usf-fill-green-button"
                disabled="{{!vm?.submitEnabled}}"
                [ngClass]="!vm?.submitEnabled ? 'usf-fill-disabled-button':'usf-fill-green-button'"
                (click)="submit()"
                data-cy="submit-exceptions-resolution-button"
                >{{ 'i18n.orderExceptionsPage.submitResolvedExceptions' |
                translate }}</ion-button
              >
              <ion-button
                *ngIf="vm?.showResolveLater"
                class="usf-outline-green-button"
                (click)="resolveLaterClicked()"
                data-cy="submit-exceptions-resolve-later-button"
              >
                {{ 'i18n.orderExceptionsPage.resolveLater' | translate}}
              </ion-button>
            </div>
          </div>
        </ion-grid>
      </div>
      <div class="bottom-section-background">
        <ng-container
          *ngFor="let item of vm?.orderExceptions| keyvalue; trackBy: trackByIndex; let first = first"
        >
          <app-exception-section-mobile
            [orderExceptionType]="item.key"
            [exceptionResolutions]="item.value"
            [productMap]="vm?.productMap"
            [searchForSubsMap]="vm?.searchForSubsMap"
            [isExpanded]="vm.expandedSection.get(item.key)"
            [platformEnum]="platformService.platformType"
            [orderHeader]="vm?.order?.orderHeader"
            [selectedDate]="selectedDate"
            [restrictToOg]="vm?.restrictToOg"
            [substitutionsAllowed]="vm?.substitutionsAllowed"
            (exceptionResolved)="resolveExceptionHandler($event)"
            (isExpandedChanged)="isExpandedChanged($event, item.key)"
            (searchForSubsClicked)="openSearchForSubs($event)"
            (compareProductsClicked)="navigateToCompareProductsPage($event)"
            (updatePriceEmitter)="presentHandPricingModal($event)"
            (partialReserveFlagResolved)="resolvepartialReserveFlag($event)"
            (substituteProductFlipped)="flipSubstituteProduct($event)"
            (editRowResolved)="editRowClicked($event)"
            (cancelEditRow)="cancelEditRowHandler($event)"
            (updateDateEmitter)="updateDateHandler($event)"
            [isExpandedFirstRow]="first"
            [sellerPrice]="vm?.sellerPrice"
          ></app-exception-section-mobile>
        </ng-container>
      </div>
    </div>
  </ng-container>
</ion-content>
